export const refinementRemovedEventName = 'refinementRemoved';
export const refinementsClearedEventName = 'refinementsCleared';
